import { mutate } from "swr";
import { fetchApi, FetchError } from "lib/actions/fetcher";
import { endpointsAssets } from "lib/actions/endpoints/endpointsAssets";
import { endpointsAutodeskImport } from "./endpointsAutodeskImport";
import { AutodeskImportSelectionModel } from "../types/AutodeskImportSelectionModel";
import { AutodeskImportRefusalModel } from "../types/AutodeskImportPreviewModel";
import { AutodeskImportOutcomeModel } from "../types/AutodeskImportOutcomeModel";

export type AutodeskImportSelectionResult =
  | { status: "started"; outcomes: AutodeskImportOutcomeModel[] }
  | { status: "refused"; refusal: AutodeskImportRefusalModel };

/**
 * Starts an import for every file the selection covers. Some can fail while
 * the rest start, so check each outcome's `failure`.
 */
export async function importAutodeskSelection(
  selection: AutodeskImportSelectionModel,
): Promise<AutodeskImportSelectionResult> {
  try {
    const response = await fetchApi({
      ...endpointsAutodeskImport.selection,
      body: { ...selection },
    });
    const outcomes: AutodeskImportOutcomeModel[] = await response.json();
    mutate(endpointsAssets.projectIngresses(selection.projectId));
    return { status: "started", outcomes };
  } catch (error) {
    if (!isRefusal(error)) throw error;
    return { status: "refused", refusal: error.response.data };
  }
}

function isRefusal(
  error: unknown,
): error is FetchError & { response: { data: AutodeskImportRefusalModel } } {
  if (!(error instanceof FetchError) || error.status !== 422) return false;
  const data = error.response.data;
  return typeof data === "object" && data !== null && "limit" in data;
}
